import { ReactNode } from 'react'
import { DateTime } from 'luxon'
import { faPencil } from '@fortawesome/pro-regular-svg-icons'
import {
  QuarterlyTaxEstimateDetail,
  QuarterlyTaxEstimateDetailStatuses,
} from '../quarterlyTaxEstimateDetails.slice'
import { DATE_FORMATS_LUXON } from '@/utils/dateHelpers'
import { IconButton, Table } from '@/componentsV1/BaseComponents'

interface Props {
  details: QuarterlyTaxEstimateDetail
  onEditClick: () => void
}

const StyledCell = ({
  children,
  status,
}: {
  children: ReactNode
  status: QuarterlyTaxEstimateDetailStatuses
}) => (
  <Table.Cell positive={status === QuarterlyTaxEstimateDetailStatuses.active}>
    {children}
  </Table.Cell>
)

const QuarterlyTaxEstimateDetailsRow = ({ details, onEditClick }: Props) => (
  <Table.Row>
    <StyledCell status={details.status}>
      {details.status !== QuarterlyTaxEstimateDetailStatuses.past && (
        <IconButton icon={faPencil} onClick={onEditClick} />
      )}
    </StyledCell>
    <StyledCell status={details.status}>{details.taxYear}</StyledCell>
    <StyledCell status={details.status}>Q{details.taxQuarter}</StyledCell>
    <StyledCell status={details.status}>{details.status}</StyledCell>
    <StyledCell status={details.status}>
      {DateTime.fromISO(details.irsQuarterStartsAt, { zone: 'utc' }).toFormat(
        DATE_FORMATS_LUXON.DISPLAY_SHORT
      )}
    </StyledCell>
    <StyledCell status={details.status}>
      {DateTime.fromISO(details.irsQuarterEndsAt, { zone: 'utc' }).toFormat(
        DATE_FORMATS_LUXON.DISPLAY_SHORT
      )}
    </StyledCell>
    <StyledCell status={details.status}>
      {DateTime.fromISO(details.irsPaymentDueAt, { zone: 'utc' }).toFormat(
        DATE_FORMATS_LUXON.DISPLAY_SHORT
      )}
    </StyledCell>
    <StyledCell status={details.status}>
      {DateTime.fromISO(details.newUserCutOffAt, { zone: 'utc' }).toFormat(
        DATE_FORMATS_LUXON.DISPLAY_SHORT
      )}
    </StyledCell>
    <StyledCell status={details.status}>
      {details.checklistLaunchDate
        ? DateTime.fromISO(details.checklistLaunchDate, {
            zone: 'utc',
          }).toFormat(DATE_FORMATS_LUXON.DISPLAY_SHORT)
        : '--'}
    </StyledCell>
    <StyledCell status={details.status}>
      {DateTime.fromISO(details.calculationStartsAt, { zone: 'utc' }).toFormat(
        DATE_FORMATS_LUXON.DISPLAY_SHORT
      )}
    </StyledCell>
    <StyledCell status={details.status}>
      {DateTime.fromISO(details.clientNotifiedAt, { zone: 'utc' }).toFormat(
        DATE_FORMATS_LUXON.DISPLAY_SHORT
      )}
    </StyledCell>
    <StyledCell status={details.status}>
      {DateTime.fromISO(details.bookkeepingPeriodStartsAt, {
        zone: 'utc',
      }).toFormat(DATE_FORMATS_LUXON.DISPLAY_SHORT)}
    </StyledCell>
    <StyledCell status={details.status}>
      {DateTime.fromISO(details.bookkeepingPeriodEndsAt, {
        zone: 'utc',
      }).toFormat(DATE_FORMATS_LUXON.DISPLAY_SHORT)}
    </StyledCell>
    <StyledCell status={details.status}>
      {details.bookkeepingPeriodTotalMonths}
    </StyledCell>
    <StyledCell status={details.status}>
      {details.edgeCaseUserIds ? details.edgeCaseUserIds.join(', ') : ''}
    </StyledCell>
    <StyledCell status={details.status}>
      {DateTime.fromISO(details.updatedAt).toFormat(
        DATE_FORMATS_LUXON.DISPLAY_SHORT
      )}
    </StyledCell>
  </Table.Row>
)

export default QuarterlyTaxEstimateDetailsRow
